import { render } from "./PortfolioCarousel.vue?vue&type=template&id=5513ec50&scoped=true"
import script from "./PortfolioCarousel.vue?vue&type=script&lang=js"
export * from "./PortfolioCarousel.vue?vue&type=script&lang=js"

import "./PortfolioCarousel.vue?vue&type=style&index=0&id=5513ec50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5513ec50"]])

export default __exports__